import {
    Box,
    Button,
    Grid,
    InputAdornment,
    TextField,
} from '@mui/material';
import { Add, SearchOutlined } from '@mui/icons-material';
import { useEffect, useRef, useState } from 'react';
import { RoleControllerAction, RoleControllerState } from '../../controller/role.controller';
import { useDebounce } from '../../../../hooks/use-debounce';


interface IProps {
    ctrl: RoleControllerState & RoleControllerAction
    handleOpenDialog: () => void;
}

const Header = ({ handleOpenDialog, ctrl }: IProps) => {
    const [roleName, setRoleName] = useState('');
    const debouncedRoleName = useDebounce(roleName, 500);
    // The page already loads the first list; only refetch once the box is used.
    const isFirstRun = useRef(true);

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        const updated = { ...ctrl.filter, skip: 0 };
        if (debouncedRoleName.trim() === '') {
            delete updated.role_name;
        } else {
            updated.role_name = debouncedRoleName.trim();
        }
        ctrl.onPageChange(0, ctrl.pageRowAmount);
        ctrl.onFilterChange(updated);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedRoleName]);

    return (
        <Box sx={{ py: 3, px: 3 }}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={3}>
                    <TextField
                        value={roleName}
                        onChange={(e) => setRoleName(e.target.value)}
                        size="small"
                        placeholder="ປ້ອນຊື່ບົດບາດ"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchOutlined />
                                </InputAdornment>
                            ),
                            style: {
                                borderRadius: '30px',
                            },
                        }}
                        fullWidth
                    />
                </Grid>
                <Box flex={1} />
                <Grid
                    item
                    xs={12}
                    md={3}
                    sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}
                >
                    <Button
                        variant="contained"
                        sx={{ width: { md: '84%', xs: '100%' }, borderRadius: 5 }}
                        onClick={handleOpenDialog}
                        fullWidth
                    >
                        <Add /> ເພີ່ມບົດບາດ
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Header;
